import { requiredRule, getRuleLen } from '../../../../utils/rules';
import { Button, Form, Icon, Input } from '@roo/roo';
import React from 'react';
import { UploadField } from '../../_components/UploadField';
import { FieldList } from '../../_components/FieldList';

const { Field } = Form;

const propertyData = {
  propertyName: '',
  propertyType: '',
  applyNumber: '',
  fileUrl: [],
};

// 知识产权
export const Property = function (props) {
  return (
    <FieldList
      {...props}
      name={'propertyInfo'}
      maxCount={5}
      minCount={0}
      plusText={'添加知识产权情况'}
      iniData={propertyData}
      itemClassName={'form-patch bc'}
    >
      <Field
        required={true}
        rule={getRuleLen(20, true)}
        name={`propertyName`}
        label='知识产权名称'
        as={<Input maxLength={50} placeholder={'请输入知识产权名称'} />}
      />
      <Field
        required={true}
        rule={getRuleLen(20, true)}
        name={`propertyType`}
        label='知识产权类别'
        as={<Input maxLength={50} placeholder={'如著作权，专利权，商标权等'} />}
      />
      <Field
        required={true}
        rule={getRuleLen(50, true)}
        name={`applyNumber`}
        label='申请号/登记号/授权号'
        as={<Input maxLength={50} placeholder={'请输入知识产权授权号'} />}
      />
      <Field
        label='知识产权文件上传'
        layout='vertical'
        name={`fileUrl`}
        required={true}
        rule={{ ...requiredRule, type: 'array' }}
      >
        {({ value, handleChange }) => {
          return (
            <UploadField maxFiles={3} type={'img'} value={value} handleChange={handleChange} />
          );
        }}
      </Field>
    </FieldList>
  );
};
